module.exports = __webpack_public_path__ + "static/media/15.6acdf3c1.jpg";